// extracted by mini-css-extract-plugin
export default {"org":"left-table_org__ATOL4","limitedCell":"left-table_limitedCell__7SvSi","summary":"left-table_summary__OrT62","placeHolderShimmer":"left-table_placeHolderShimmer__Selqs"};